import { render, staticRenderFns } from "./RelatedBusinessesButton.vue?vue&type=template&id=69d7d34a&scoped=true&"
import script from "./RelatedBusinessesButton.vue?vue&type=script&lang=ts&"
export * from "./RelatedBusinessesButton.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedBusinessesButton.vue?vue&type=style&index=0&id=69d7d34a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d7d34a",
  null
  
)

export default component.exports